import { UrlConfig } from 'config';
import { AjaxService } from 'services';
import { ApiResponse } from 'models/Api/ApiResponse';
import { ListingSuggestedItemsModel } from 'models';
import { RawListingSuggestedItemsResponse } from 'models/ListingSuggestedItems/types';

export class ListingSuggestedItemsApiClient {
  public static async getSuggestedItems(listingId: string): Promise<ListingSuggestedItemsModel> {
    const url = UrlConfig.LISTING_SUGGESTION.LISTING_SUGGESTED_ITEMS(listingId);
    const response: ApiResponse<RawListingSuggestedItemsResponse> = await AjaxService.getData(url);
    return new ListingSuggestedItemsModel(response.data);
  }
}
